import { createReducer } from "typesafe-actions";

import type { TAdNetworksAbout } from "../types/adNetwork";
import type { Feed, FeedActions } from "../types/feed";
import type { SiteInfo } from "../types/siteInfo";
import type { TTopCountries } from "../types/topCountries";

import * as ac from "./action-creators";

export type FeedState = {
    feeds: Feed[];
    topCountries: TTopCountries;
    topCountriesFetching: boolean;
    fetchingFeeds: boolean;
    fetchingFeedsError?: string;
    adNetworks: TAdNetworksAbout;
    siteInfo: SiteInfo;
    isSiteInfoBeingFetched: boolean;
};

const INITIAL_FEED_STATE: FeedState = {
    feeds: [],
    fetchingFeeds: false,
    topCountries: {
        topCountriesByGrowth: [],
        topCountriesByShare: [],
    },
    topCountriesFetching: false,
    adNetworks: {
        topAdNetworks: [],
        newAdNetworks: [],
    },
    siteInfo: {
        category: "",
        companyDescription: "",
        functionality: "",
        monthlyVisits: 0,
        rank: 0,
        visitsMoM: 0,
        visitsYoY: 0,
        favIcon: "",
        mainDomain: "",
        industry: undefined,
        siteTypes: [],
    },
    isSiteInfoBeingFetched: false,
};

const feedReducer = createReducer<FeedState, FeedActions>(INITIAL_FEED_STATE)
    .handleAction(ac.fetchFeedsAsyncAction.request, (state) => ({
        ...state,
        fetchingFeeds: true,
        fetchingFeedsError: INITIAL_FEED_STATE.fetchingFeedsError,
    }))
    .handleAction(ac.fetchFeedsAsyncAction.success, (state, { payload }) => ({
        ...state,
        feeds: payload,
        fetchingFeeds: false,
    }))
    .handleAction(ac.fetchFeedsAsyncAction.failure, (state, { payload }) => ({
        ...state,
        fetchingFeeds: false,
        fetchingFeedsError: payload,
    }))
    .handleAction(ac.fetchAdNetworksAsyncAction.request, (state) => ({
        ...state,
        adNetworks: INITIAL_FEED_STATE.adNetworks,
    }))
    .handleAction(ac.fetchSiteInfoAsyncAction.request, (state) => ({
        ...state,
        siteInfo: INITIAL_FEED_STATE.siteInfo,
        isSiteInfoBeingFetched: true,
    }))
    .handleAction(ac.fetchSiteInfoAsyncAction.success, (state, { payload }) => ({
        ...state,
        siteInfo: payload,
        isSiteInfoBeingFetched: false,
    }))
    .handleAction(ac.fetchSiteInfoAsyncAction.failure, (state) => ({
        ...state,
        isSiteInfoBeingFetched: false,
    }))
    .handleAction(ac.resetSiteInfoAction, (state) => ({
        ...state,
        siteInfo: INITIAL_FEED_STATE.siteInfo,
    }))
    .handleAction(ac.fetchTopCountriesAsyncAction.request, (state) => ({
        ...state,
        topCountries: INITIAL_FEED_STATE.topCountries,
        topCountriesFetching: true,
    }))
    .handleAction(ac.fetchTopCountriesAsyncAction.success, (state, { payload }) => ({
        ...state,
        topCountries: payload,
        topCountriesFetching: false,
    }))
    .handleAction(ac.fetchTopCountriesAsyncAction.failure, (state) => ({
        ...state,
        topCountriesFetching: false,
    }))
    .handleAction(ac.fetchAdNetworksAsyncAction.success, (state, { payload }) => ({
        ...state,
        adNetworks: payload,
    }));

export default feedReducer;
